import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import DateCarousel from '../../../components/common/DateCarousel';
import ListBoxField from '../../../components/common/ListBoxField';
import Preloader from '../../../components/common/Preloader';
import { isLoading } from '../../../modules/events/selectors';
import getDatesRange from '../../../utils/dates/getDatesRange';
import CompetitionList from '../../common/CompetitionList';
import { setEventsDay, setMarketGroupId, viewEnter } from '../actions';
import EventTile from '../EventTile';
import MarketHeader from '../MarketHeader';
import {
  MARKET_GROUP_90_MINUTES,
  MARKET_GROUP_BOTH_TEAMS_TO_SCORE,
  MARKET_GROUP_OVER_UNDER_X_GOALS,
  MARKET_GROUP_RESULT_AND_BOTH_TEAMS_TO_SCORE
} from '../reducer';
import { getEventsDay, getMarketGroupId } from '../selectors';

const marketGroups = [
  {
    value: MARKET_GROUP_90_MINUTES,
    label: '90 Minutes',
    selectionLabels: ['Home', 'Draw', 'Away']
  },
  {
    value: MARKET_GROUP_OVER_UNDER_X_GOALS,
    label: 'Over/Under 2.5 Goals',
    selectionLabels: ['Under', 'Over']
  },
  {
    value: MARKET_GROUP_BOTH_TEAMS_TO_SCORE,
    label: 'Both Teams To Score',
    selectionLabels: ['Yes', 'No']
  },
  {
    value: MARKET_GROUP_RESULT_AND_BOTH_TEAMS_TO_SCORE,
    label: 'Result & Both Teams To Score',
    selectionLabels: ['Home', 'Draw', 'Away']
  }
];

export class Events extends React.Component {
  componentDidMount() {
    this.props.viewEnter();
  }

  render() {
    const { loading, currentDay, setDay, marketGroupId, setMarketGroup } = this.props;
    const { selectionLabels } = marketGroups.filter(m => m.value === marketGroupId)[0];

    return (
      <div className="betting-buddy-events">
        <div className="betting-buddy-events__header">
          <DateCarousel activeDate={currentDay} setDate={setDay} dates={getDatesRange()} />
          <div className="betting-buddy-events__market-groups">
            <ListBoxField
              value={marketGroupId}
              options={marketGroups}
              className="list-box-field--dark"
              onChange={setMarketGroup}
            />
          </div>
        </div>
        <div className="betting-buddy-events__main">
          {loading ? (
            <div className="betting-buddy-events__preloader">
              <Preloader darkBackground>Loading events...</Preloader>
            </div>
          ) : (
            <CompetitionList
              header={marketName => (
                <MarketHeader selectionLabels={selectionLabels} marketName={marketName} />
              )}
              event={(eventId, marketName) => (
                <EventTile key={eventId} eventId={eventId} marketName={marketName} />
              )}
            />
          )}
        </div>
      </div>
    );
  }
}

Events.propTypes = {
  viewEnter: PropTypes.func.isRequired,
  setDay: PropTypes.func.isRequired,
  setMarketGroup: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  currentDay: PropTypes.number.isRequired,
  marketGroupId: PropTypes.string.isRequired
};

const mapStateToProps = state => ({
  loading: isLoading(state),
  currentDay: getEventsDay(state),
  marketGroupId: getMarketGroupId(state)
});

const mapDispatchToProps = {
  viewEnter,
  setDay: setEventsDay,
  setMarketGroup: setMarketGroupId
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Events)
);
